import React from 'react';
import ReactDOM from 'react-dom/client';
import { Provider } from 'react-redux';
import { HelmetProvider } from 'react-helmet-async';
import { RouterProvider } from 'react-router-dom';

// Components
import App from './App.js';

// Routes
import { router } from './routes';

// Store
import { store } from './store';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <Provider store={store}>
      <RouterProvider router={router}>
        <HelmetProvider>
          <App />
        </HelmetProvider>
      </RouterProvider>
    </Provider>
  </React.StrictMode>,
);
